var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperAdminMenuIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 23,
    height: 24,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M9.70378 11.0094C12.005 11.0094 13.8704 9.14388 13.8704 6.84269C13.8704 4.54151 12.005 2.67603 9.70378 2.67603C7.40259 2.67603 5.53711 4.54151 5.53711 6.84269C5.53711 9.14388 7.40259 11.0094 9.70378 11.0094Z",
    stroke: "#707494",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M12.225 15.176H6.57878C5.47371 15.176 4.4139 15.615 3.6325 16.3964C2.8511 17.1778 2.41211 18.2376 2.41211 19.3427V21.426",
    stroke: "#707494",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M19.5791 18.801C21.305 18.801 22.7041 17.4019 22.7041 15.676C22.7041 13.9501 21.305 12.551 19.5791 12.551C17.8532 12.551 16.4541 13.9501 16.4541 15.676C16.4541 17.4019 17.8532 18.801 19.5791 18.801Z",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M23.4336 17.1343L22.4961 16.8218",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M16.6621 14.5303L15.7246 14.2178",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M18.1211 19.5303L18.4336 18.5928",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M20.7246 12.7593L21.0371 11.8218",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M21.2459 19.5303L20.9101 18.6482",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M18.2914 12.6905L17.9121 11.8218",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M15.7246 17.3427L16.6547 17.0442",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-none",
    d: "M22.5469 14.3273L23.4329 14.0093",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperAdminMenuIcon);
export default __webpack_public_path__ + "static/media/SuperAdminMenuIcon.153625ce389c5f5cd7b8e68a44b10c68.svg";
export { ForwardRef as ReactComponent };